import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  name: string;
  errorMessage?: string;
}

@Component({
  standalone: false,
  selector: 'app-add-message-type-dialog',
  templateUrl: 'add-message-type-dialog.component.html',
  styleUrls: ['add-message-type-dialog.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AddMessageTypeDialogComponent {
  errorMessage: string;
  onAddCallback: ((messageType: string) => void) | null = null;

  constructor(
    public dialogRef: MatDialogRef<AddMessageTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.errorMessage = data.errorMessage || '';
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onInputChange(event: any): void {
    if (this.data.name) {
      this.data.name = this.data.name.toUpperCase();
    }
  }

  onAddClick(): void {
    if (this.onAddCallback && this.data.name && this.data.name.length > 0 && this.data.name.length <= 30) {
      this.onAddCallback(this.data.name);
    }
  }
}

